import { createContext, useContext } from "react";

interface OrgConnectValue {
    organizationId: string;
}

/**
 * Marks a connect flow as organization-level: the accounting firm is connecting
 * an integration with no client selected yet, so the provider's own flow runs
 * without a workspace and the resulting accounts are assigned to a client and
 * entity afterwards. Absent in the workspace flows, which keep their existing
 * behavior.
 */
export const orgConnectContext = createContext<OrgConnectValue | null>(null);

export function useOrgConnect(): OrgConnectValue | null {
    return useContext(orgConnectContext);
}
